var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header--wrap"},[_c('div',{staticClass:"header"},[_c('h2',{staticClass:"logo"},[_c('h2',[_vm._v("OCR")])])])])
}]

export { render, staticRenderFns }